import {environment} from '../../environments/environment';
const authService = {
  getRefreshToken: () => localStorage.getItem('REFRESH_TOKEN'),
  getReference: () => localStorage.getItem('REFERENCE'),
  getAccount: () => localStorage.getItem('ACCOUNT'),
  getUsername: () => localStorage.getItem('USERNAME'),
  getUserId: () => localStorage.getItem('USER_ID'),
  getRole: () => +localStorage.getItem('ROLE'),
  getAccessToken: () => localStorage.getItem('ACCESS_TOKEN'),
  getPlanId:()=>localStorage.getItem("PLAN_ID"),
  getCorporateId:()=>localStorage.getItem("CORPORATE_ID"),
  signOut: () => localStorage.clear(),
  loadCredential(credential) {
    localStorage.setItem('ACCESS_TOKEN', credential.access_token);
    localStorage.setItem('ACCOUNT', credential.references[0]);
    localStorage.setItem('REFERENCE', credential.references[0]);
    localStorage.setItem('REFRESH_TOKEN', credential.refresh_token);
    localStorage.setItem('ROLE', credential.role);
    localStorage.setItem('USER_ID', credential.id);
  },
  isAzureUser: () => authService.getPlanId()!=undefined||null,
  isAzurePlanEntryAllowed: () => authService.getPlanId() && environment.azure.planEntryId == authService.getPlanId(),//only for azure users TODO work on subordinates of azure users
  isAzurePlanSnapAllowed: () => (authService.getPlanId() && environment.azure.planSnapId == authService.getPlanId()),
  isSuperAdmin: () => authService.getRole() === 1,
  isSystemAdmin: () => authService.getRole() <100,
  isCorporateSAASAdmin: () => authService.getRole() === 101,
  isCorporateAdmin:()=>authService.getRole()==100,
  isMaintenaceLevelUser:()=>[2000,3000].includes(authService.getRole()),
  isProjectAdminUser:()=>authService.getRole()==1000,
  hasCorporateMenuAccess:()=>authService.getRole()<1000,
  hasEntityManagementAccess:()=>authService.getRole()<=1000 ,
  hasProjectManagementAccess:()=>authService.getRole()<=1000 ,
  hasProjectUserManagementAccess:()=>[1,100,101].includes(authService.getRole()),
  hasKitUpdateAccess:()=>authService.getRole()<10000,
  isMobileSAASAdmin: () => authService.getRole() === 101 &&!authService.isAzureUser(),
  hasUserCreationAccess:()=> !['Client_User'].includes(authService.getRole())
}

export default authService;